"use client";

import React from 'react';
import { DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { CircleCheck } from 'lucide-react';

type Props = {
  onContinue: () => void;
  continueLabel?: string;
}

// Окно 4 «Согласие подписано».
export default function ConsentDoneStep({ onContinue, continueLabel = 'Перейти к загрузке фото' }: Props)
{
  return (
    <>
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2">
          <CircleCheck className="h-5 w-5 text-green-600" />
          Согласие подписано
        </DialogTitle>
        <DialogDescription>
          Согласие на передачу медиа материалов подписано. Оно действует бессрочно —
          подписывать его повторно не потребуется.
        </DialogDescription>
      </DialogHeader>

      <DialogFooter>
        <Button onClick={onContinue} className="w-full sm:w-auto">
          {continueLabel}
        </Button>
      </DialogFooter>
    </>
  );
}
